import { render, staticRenderFns } from "./Filiale.vue?vue&type=template&id=03ef204e&scoped=true"
import script from "./Filiale.vue?vue&type=script&lang=js"
export * from "./Filiale.vue?vue&type=script&lang=js"
import style0 from "./Filiale.vue?vue&type=style&index=0&id=03ef204e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ef204e",
  null
  
)

export default component.exports